import api from './api';

export const login          = (email, password)           => api.post('/api/auth/login', { email, password });
export const smartLogin     = (email, password)           => api.post('/api/auth/smart-login', { email, password });
export const loginToClub    = (email, password, clubId)   => api.post('/api/auth/login-to-club', { email, password, clubId });
export const getMe          = ()                           => api.get('/api/auth/me');
export const register       = (data)                      => api.post('/api/auth/register', data);
export const verifyEmail    = (token)                     => api.get(`/api/auth/verify-email/${token}`);
export const forgotPassword = (email)                     => api.post('/api/auth/forgot-password', { email });
export const resetPassword  = (token, password)           => api.post(`/api/auth/reset-password/${token}`, { password });
export const checkEmail     = (email)                     => api.post('/api/auth/check-email', { email });
